import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuthStore } from '@/stores/auth'
import { Sidebar } from '@/components/sidebar'
import { useSidebarStore } from '@/stores/sidebar'
import { useColors } from '@/lib/utils'
import { useThemeStore } from '@/stores/theme'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    const { isAuthenticated, userToken, isInitialized, initialize, checkSession } = useAuthStore.getState()
    
    // Initialize auth state if not already done
    if (!isInitialized) {
      await initialize()
    }
    
    // Check session validity
    const sessionValid = checkSession()
    
    console.log('[Auth] beforeLoad check - isAuthenticated:', isAuthenticated, 'userToken:', !!userToken, 'sessionValid:', sessionValid)
    
    if (!isAuthenticated || !userToken || !sessionValid) {
      console.log('[Auth] Not authenticated or no token, redirecting to login')
      throw redirect({ to: '/login' })
    }
    
    console.log('[Auth] Authentication check passed')
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { isCollapsed } = useSidebarStore()
  const { isDarkMode } = useThemeStore()
  const Colors = useColors(isDarkMode)
  const { isAuthenticated, userToken, checkSession } = useAuthStore()

  // Additional runtime check
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAuthenticated || !userToken || !checkSession()) {
        console.log('[Auth] Runtime check failed, redirecting to login')
        window.location.href = '/login'
      }
    }, 30000) // Check every 30 seconds

    return () => clearInterval(interval)
  }, [isAuthenticated, userToken, checkSession])

  return (
    <div className="flex h-screen" style={{ backgroundColor: Colors.background.default }}>
      <Sidebar />
      <main 
        className="flex-1 overflow-auto transition-all duration-300"
        style={{ marginLeft: isCollapsed ? 72 : 250 }}
      >
        <Outlet />
      </main>
    </div>
  )
}